<template>
  <div class='grid grid-cols-1 gap-y-4'>
    <tree-data-table :items='devices' :headers='headers'/>
    <home-chart :selecteddevice="selecteddevice" :start="tsRange.start" :end="tsRange.end"></home-chart>
  </div>
</template>

<script>
import TreeDataTable from '@/components/TreeDataTable/TreeDataTable'
import HomeChart from '@/components/HomeChart/HomeChart'
import dayjs from 'dayjs'
export default {
  name: 'home',
  components: { TreeDataTable, HomeChart },
  async mounted() {
    let response = await this.$http.get(`/griddataheaders`)
    this.headers = response.data
    await this.$store.dispatch('getDevices')
    this.devices = this.$store.getters.devices
  },
  data() {
    return {
      selecteddevice: {},
      devices: [],
      headers: []
    };
  },
  methods: {
    toggleNode(node, open) {
      this.$store.dispatch('toggleNode', node)
      console.log(node, open)
    },
    onRowClicked(obj) {
      this.selecteddevice = obj
    },
    async onRowDblClicked(obj) {
      await this.$store.dispatch('updateCurrentDevice', obj)
      this.$router.push({ path: '/mtcontrol/device/' + obj.devid  });
    }
  },
  computed: {
    tsRange() {
      let tstart = dayjs().subtract(2, 'day').unix().toString()
      let tend = dayjs().unix().toString()
      return { start: tstart, end: tend }
    }
  }
}
</script>

<style scoped>
  /*.home {
  }*/
</style>
